import styled, { keyframes } from "styled-components";

const move = keyframes`
  0%{
    color: white;
    /* font-size: 1.5em; */
  }
  30%{
    color: orangered;
  }
  60%{
    color: teal;
  }
  100%{
    color: white;
  }
`;

// const backimg = "../../../assets/images/blog3.png";

export const Wrapper = styled.div`
  width: 100%;
  background: ${({ themed }) => (themed ? "#0F0E37" : "#fff")};

  .image {
    display: none;
  }

  @media (min-width: 789px) {
    background-repeat: no-repeat;
    background-size: cover;
    padding-left: 40%;
    position: relative;

    .image {
      display: block;
      position: absolute;
      top: 45%;
      left: 7%;
      width: 20%;
    }
  }

  @media (min-width: 1100px) {
    padding-left: 30%;
    min-height: 50vh;
  }
`;
export const Container = styled.div`
  min-height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1em;
`;
export const Content = styled.div``;
export const H1 = styled.h1`
  font-size: 3em;
  font-weight: 700;
  animation: ${move} 4s infinite;
`;
export const H2 = styled.h2`
  font-size: 2.5em;
  font-weight: 500;

  @media (min-width: 789px) {
    color: #fd6f44;
  }
`;
export const P = styled.p`
  font-size: 1.1em;
  font-weight: 400;
  line-height: 1.5;
  color: #999;
`;
export const Button = styled.button``;
